export const PROGRESS_STATES = [
  {
    stateName: 'app.status.started',
    stepTitleKey: 'app.status.started',
    progressbarIcon: 'fa fa-bank',
  },
  {
    stateName: 'app.status.transmitted',
    stepTitleKey: 'app.status.transmitted',
    progressbarIcon: 'fa fa-exchange',
  },
  {
    stateName: 'app.status.shipped',
    stepTitleKey: 'app.status.notShipped',
    progressbarIcon: 'fa fa-paper-plane',
  },
];



// WEBPACK FOOTER //
// ./src/app/components/status/status.constants.js